module.exports = __webpack_public_path__ + "static/media/icon_print.7942dbc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_print.svg
// module id = 321
// module chunks = 0